const mutations = {
  setB2B(state, value) {
    if (!value || Object.keys(value).length === 0) {
      return;
    }

    if (value !== '' && value !== false) {
      state.b2bUser = true;
      state.b2b = value;
    }
  }
};

export default mutations;
